<template>
    <div>
        <v-currency-field
            :label="label"
            v-on:input="$emit('input', $event)"
            :value="value"
            :rules="optional ? [] : payRules"
            outlined
            dense
            class="soli-round"
            error-message="errors.amount"
            prepend-inner-icon="payments"
            :hide-details="hideDetails"
        ></v-currency-field>
    </div>
</template>

<script>
export default {
    props: {
        value: {},
        label: {},
        optional: {
            type: Boolean,
            default: false,
        },
        hideDetails: {
            type: [Boolean, String],
            default: false,
        },
    },
    data: function () {
        return {
            payRules: [
                (v) =>
                    !v ||
                    v >= 0 ||
                    "Pay Rate must be greater than or equal to $0",
                (v) => !v || v <= 100 || "Pay Rate can't be greater than $100",
                (v) => (v || "").length > 0 || "Pay rate is required",
            ],
            rateFormCopy: null,
            editRateForm: false,
            groupEventRate: null,
            showPayRateForm: false,
        };
    },
};
</script>
